module.exports = __webpack_public_path__ + "img/ChildCareOutlined.b133894e.svg";